/**
 * @generated SignedSource<<08f883439adbcc14519ceb298792c99f>>
 * @relayHash 597a43dbe86abad66a7fe0ba2fed86f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d5fe33bbdab90e811d2427bccc354f6922e6dd60542c5e700d67daf0fd3c7f7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueChangeInput = {
  issueId: string;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchViewContextInput = {
  expandedGroups?: JiraIssueExpandedGroups | null | undefined;
  expandedParents?: ReadonlyArray<JiraIssueExpandedParent> | null | undefined;
};
export type JiraIssueExpandedGroups = {
  groupedByFieldId: string;
  groups?: ReadonlyArray<JiraIssueExpandedGroup> | null | undefined;
};
export type JiraIssueExpandedGroup = {
  fieldValue?: string | null | undefined;
  first?: number | null | undefined;
  jql: string;
};
export type JiraIssueExpandedParent = {
  first?: number | null | undefined;
  parentIssueId: string;
};
export type realtimeIssueDetails_Query$variables = {
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  isDensityFull: boolean;
  isHierarchyEnabled: boolean;
  isInlineEditingEnabled: boolean;
  isIssueViewChildIssuesPanelRealtimeUpdateEnabled: boolean;
  isStatusTrackingEnabled: boolean;
  issueAris: ReadonlyArray<string>;
  issueChanges: ReadonlyArray<JiraIssueChangeInput>;
  issueSearchInput: JiraIssueSearchInput;
  projectKey: string;
  searchViewContextInput: JiraIssueSearchViewContextInput;
  staticViewInput: JiraIssueSearchStaticViewInput;
};
export type realtimeIssueDetails_Query$data = {
  readonly jira: {
    readonly searchViewContexts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly contexts: ReadonlyArray<{
            readonly position: number;
            readonly sourceIssueId: string;
          }> | null | undefined;
          readonly jql?: string | null | undefined;
          readonly parentIssueId?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira_issuesByIds: ReadonlyArray<{
    readonly __id: string;
    readonly canHaveChildIssues?: boolean | null | undefined;
    readonly fieldSetsById: {
      readonly __id: string;
      readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets">;
    } | null | undefined;
    readonly isResolved?: boolean | null | undefined;
    readonly issueId: string;
    readonly issueTypeField?: {
      readonly id: string;
      readonly issueType: {
        readonly hierarchy: {
          readonly level: number | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly parentIssueField: {
      readonly parentIssue: {
        readonly __id: string;
      } | null | undefined;
    } | null | undefined;
    readonly statusField?: {
      readonly status: {
        readonly statusCategory: {
          readonly statusCategoryId: string;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type realtimeIssueDetails_Query = {
  response: realtimeIssueDetails_Query$data;
  variables: realtimeIssueDetails_Query$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDensityFull"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHierarchyEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIssueViewChildIssuesPanelRealtimeUpdateEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStatusTrackingEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAris"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueChanges"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchViewContextInput"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v13 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "issueAris"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v15 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v16 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "condition": "isIssueViewChildIssuesPanelRealtimeUpdateEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isResolved"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
},
v20 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v21 = {
  "args": [
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "canHaveChildIssues"
},
v22 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v23 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueChanges",
    "variableName": "issueChanges"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "searchViewContextInput",
    "variableName": "searchViewContextInput"
  },
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "parentIssueId"
    }
  ],
  "type": "JiraIssueSearchBulkViewParentContexts"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    }
  ],
  "type": "JiraIssueSearchBulkViewGroupContexts"
},
v26 = {
  "kind": "ScalarField",
  "name": "sourceIssueId"
},
v27 = {
  "kind": "ScalarField",
  "name": "position"
},
v28 = {
  "kind": "ScalarField",
  "name": "type"
},
v29 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v30 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v31 = {
  "kind": "ScalarField",
  "name": "name"
},
v32 = {
  "kind": "ScalarField",
  "name": "value"
},
v33 = [
  (v32/*: any*/),
  (v19/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v34 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v35 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v36 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v37 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v38 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v39 = {
  "kind": "ScalarField",
  "name": "text"
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    (v31/*: any*/),
    (v34/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v41 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v42 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v19/*: any*/)
  ]
},
v43 = [
  (v42/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v45 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v46 = {
  "kind": "ScalarField",
  "name": "picture"
},
v47 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v48 = [
  (v31/*: any*/),
  (v19/*: any*/)
],
v49 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v50 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v19/*: any*/)
  ]
},
v51 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v19/*: any*/)
  ]
},
v52 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v19/*: any*/)
  ]
},
v53 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v54 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v53/*: any*/),
        (v31/*: any*/),
        (v19/*: any*/)
      ]
    },
    (v19/*: any*/)
  ]
},
v55 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v56 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v50/*: any*/),
    (v19/*: any*/)
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "number"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "realtimeIssueDetails_Query",
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v14/*: any*/),
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v15/*: any*/)
                ]
              }
            ]
          },
          {
            "args": (v16/*: any*/),
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                  },
                  {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
              },
              (v15/*: any*/)
            ]
          },
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "condition": "isHierarchyEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/)
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "condition": "isStatusTrackingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraStatusCategory",
                        "kind": "LinkedField",
                        "name": "statusCategory",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v15/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
            "kind": "LinkedField",
            "name": "searchViewContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchBulkViewContextMapping",
                        "kind": "LinkedField",
                        "name": "contexts",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v26/*: any*/),
                            "action": "THROW",
                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                          },
                          {
                            "kind": "RequiredField",
                            "field": (v27/*: any*/),
                            "action": "THROW",
                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v12/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "realtimeIssueDetails_Query",
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v14/*: any*/),
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v15/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "args": (v16/*: any*/),
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldSetId"
                      },
                      {
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueField"
                                  },
                                  (v19/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraAffectedServiceConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedAffectedServicesConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAffectedServiceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedService",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "serviceId"
                                                  },
                                                  (v31/*: any*/),
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraAffectedServicesField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraCascadingOption",
                                            "kind": "LinkedField",
                                            "name": "cascadingOption",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "parentOptionValue",
                                                "plural": false,
                                                "selections": (v33/*: any*/)
                                              },
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "childOptionValue",
                                                "plural": false,
                                                "selections": (v33/*: any*/)
                                              }
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraCascadingSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "args": (v35/*: any*/),
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponent",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v36/*: any*/),
                                                      (v37/*: any*/),
                                                      (v19/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraComponentsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v38/*: any*/),
                                          (v31/*: any*/),
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraDateTimePickerField"
                                      },
                                      (v40/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraCommentSummary",
                                            "kind": "LinkedField",
                                            "name": "commentSummary",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "canAddComment"
                                              },
                                              (v41/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraCommentSummaryField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "uri"
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraUrlField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldOptions",
                                            "plural": false,
                                            "selections": [
                                              (v41/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "fieldOption",
                                            "plural": false,
                                            "selections": [
                                              (v32/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": (v43/*: any*/)
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": (v43/*: any*/)
                                              },
                                              (v19/*: any*/),
                                              (v44/*: any*/)
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraSingleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v32/*: any*/),
                                                      (v44/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraMultipleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraOptionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedOptions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v32/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraCheckboxesField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraUserConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedUsersConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraUserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v29/*: any*/),
                                                      (v45/*: any*/),
                                                      (v31/*: any*/),
                                                      (v46/*: any*/),
                                                      (v19/*: any*/),
                                                      (v47/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "email"
                                                          }
                                                        ],
                                                        "type": "AtlassianAccountUser"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraMultipleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraTeamView",
                                            "kind": "LinkedField",
                                            "name": "selectedTeam",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "jiraSuppliedId"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "jiraSuppliedName"
                                              }
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraTeamViewField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraTimeTrackingField",
                                                "kind": "LinkedField",
                                                "name": "timeTrackingField",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v34/*: any*/),
                                                  {
                                                    "concreteType": "JiraEstimate",
                                                    "kind": "LinkedField",
                                                    "name": "originalEstimate",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "timeInSeconds"
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraTimeTrackingSettings",
                                                    "kind": "LinkedField",
                                                    "name": "timeTrackingSettings",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "workingHoursPerDay"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "workingDaysPerWeek"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "defaultFormat"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "defaultUnit"
                                                      }
                                                    ]
                                                  },
                                                  (v30/*: any*/),
                                                  (v31/*: any*/),
                                                  (v28/*: any*/)
                                                ]
                                              },
                                              (v19/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraOriginalTimeEstimateField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "selectedOption",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "label",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              },
                                              (v19/*: any*/),
                                              (v36/*: any*/)
                                            ]
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraRadioSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "args": (v35/*: any*/),
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v31/*: any*/),
                                                      (v36/*: any*/),
                                                      (v37/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "versionId"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraMultipleVersionPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                              (v19/*: any*/)
                                            ]
                                          },
                                          {
                                            "args": (v35/*: any*/),
                                            "concreteType": "JiraGoalConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedGoals",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGoalEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": "selectedGoals(first:1000)"
                                          },
                                          (v34/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "type": "JiraGoalsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "args": (v35/*: any*/),
                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "confluenceRemoteIssueLinks",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "href"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v41/*: any*/)
                                            ],
                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                          },
                                          (v34/*: any*/)
                                        ],
                                        "type": "JiraConfluenceRemoteIssueLinksField"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraCmdbObjectConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedCmdbObjectsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraCmdbObjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "objectId"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                  },
                                                  {
                                                    "concreteType": "JiraCmdbAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbMediaClientConfig",
                                                        "kind": "LinkedField",
                                                        "name": "mediaClientConfig",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "clientId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "mediaBaseUrl"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "mediaJwtToken"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "url48"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "message"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraCMDBField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": "componentsOld",
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponent",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v48/*: any*/)
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraComponentsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v39/*: any*/)
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "date"
                                      },
                                      (v31/*: any*/),
                                      (v49/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "type": "JiraDatePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v38/*: any*/)
                                    ],
                                    "type": "JiraDateTimePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraEpic",
                                        "kind": "LinkedField",
                                        "name": "epic",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "color"
                                          },
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraEpicLinkField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "renderedFieldHtml"
                                      }
                                    ],
                                    "type": "JiraFallbackField"
                                  },
                                  (v40/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v22/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraStatusCategoryField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "statusId"
                                          },
                                          (v50/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraStatusField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": (v35/*: any*/),
                                        "concreteType": "JiraLabelConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedLabelsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraLabel",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v31/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          (v41/*: any*/)
                                        ],
                                        "storageKey": "selectedLabelsConnection(first:1000)"
                                      },
                                      (v31/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "type": "JiraLabelsField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "small"
                                              }
                                            ]
                                          },
                                          (v31/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraIssueTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "parentIssue",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v51/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v52/*: any*/),
                                              (v54/*: any*/),
                                              (v51/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v52/*: any*/),
                                              (v54/*: any*/),
                                              (v51/*: any*/),
                                              (v19/*: any*/),
                                              (v14/*: any*/),
                                              (v55/*: any*/),
                                              {
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                      "summary",
                                                      "issuetype",
                                                      "status"
                                                    ]
                                                  }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v19/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v30/*: any*/),
                                                              (v39/*: any*/)
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v30/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeId"
                                                                  },
                                                                  (v31/*: any*/),
                                                                  (v53/*: any*/),
                                                                  (v20/*: any*/),
                                                                  (v19/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v30/*: any*/),
                                                              (v56/*: any*/)
                                                            ],
                                                            "type": "JiraStatusField"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                              }
                                            ]
                                          },
                                          (v31/*: any*/),
                                          (v34/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraParentIssueField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                          },
                                          (v19/*: any*/)
                                        ]
                                      },
                                      (v31/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "type": "JiraPriorityField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "large"
                                              }
                                            ]
                                          },
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraProjectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraResolution",
                                        "kind": "LinkedField",
                                        "name": "resolution",
                                        "plural": false,
                                        "selections": (v48/*: any*/)
                                      }
                                    ],
                                    "type": "JiraResolutionField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprintConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedSprintsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraSprintEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprint",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "sprintId"
                                                  },
                                                  (v31/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "state"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "endDate"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v31/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "type": "JiraSprintField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          (v31/*: any*/),
                                          (v19/*: any*/),
                                          (v47/*: any*/)
                                        ]
                                      },
                                      (v31/*: any*/),
                                      (v49/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "type": "JiraSingleSelectUserPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*: any*/),
                                      {
                                        "args": (v35/*: any*/),
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedVersionsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v48/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                      }
                                    ],
                                    "type": "JiraMultipleVersionPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraRichText",
                                        "kind": "LinkedField",
                                        "name": "richText",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "adfValue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "condition": "isDensityFull",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                    "kind": "LinkedField",
                                                    "name": "convertedPlainText",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "plainText"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "isDensityFull",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraRichTextField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraServiceManagementRequestType",
                                        "kind": "LinkedField",
                                        "name": "requestType",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v53/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraServiceManagementRequestTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                          }
                                        ],
                                        "concreteType": "JiraIssueLinkConnection",
                                        "kind": "LinkedField",
                                        "name": "issueLinkConnection",
                                        "plural": false,
                                        "selections": [
                                          (v41/*: any*/),
                                          {
                                            "concreteType": "JiraIssueLinkEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueLink",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v55/*: any*/),
                                                      (v17/*: any*/),
                                                      {
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                              "statusCategory"
                                                            ]
                                                          }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v29/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v50/*: any*/)
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                  },
                                                                  (v19/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                      },
                                                      (v19/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "relationName"
                                                  },
                                                  (v19/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "issueLinkConnection(first:1)"
                                      }
                                    ],
                                    "type": "JiraIssueLinkField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isStoryPointField"
                                      },
                                      (v57/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          (v57/*: any*/)
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          (v57/*: any*/),
                                          (v31/*: any*/),
                                          (v34/*: any*/)
                                        ]
                                      },
                                      (v34/*: any*/)
                                    ],
                                    "type": "JiraNumberField"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v15/*: any*/)
            ]
          },
          (v17/*: any*/),
          (v19/*: any*/),
          (v18/*: any*/),
          {
            "condition": "isHierarchyEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v19/*: any*/)
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "condition": "isStatusTrackingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                  (v56/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          },
          (v15/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
            "kind": "LinkedField",
            "name": "searchViewContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchBulkViewContextMapping",
                        "kind": "LinkedField",
                        "name": "contexts",
                        "plural": true,
                        "selections": [
                          (v26/*: any*/),
                          (v27/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4d5fe33bbdab90e811d2427bccc354f6922e6dd60542c5e700d67daf0fd3c7f7",
    "metadata": {},
    "name": "realtimeIssueDetails_Query",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "d1f4b2b7b0d70e3bd8422a874a4a3603";

export default node;
